/**
 * @link https://mui.com/material-ui/react-dialog/
 */

import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';
import ShowCode from "../../helpers/ShowCode.js";

const emails = ['username@facturee.de', 'user02@facturee.de'];

function SimpleDialog(props) {
  const { onClose, selectedValue, open } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Set logistics account</DialogTitle>
      <List sx={{ pt: 0 }}>
        {emails.map((email) => (
          <ListItem disableGutters key={email}>
            <ListItemButton
              onClick={() => handleListItemClick(email)}
              key={email}>
              <ListItemAvatar>
                <Avatar variant="logistics">
                  <PersonIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={email} />
            </ListItemButton>
          </ListItem>
        ))}

      <ListItem disableGutters>
          <ListItemButton
            autoFocus
            onClick={() => handleListItemClick('addAccount')}
            key="3">
            <ListItemAvatar>
              <Avatar variant="primary">
                <AddIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="Add account" />
          </ListItemButton>
        </ListItem>
      </List>
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};

export default function FactureeDialog() {
  const [open, setOpen] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState(emails[1]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
    setSelectedValue(value);
  };

  return (
    <>
      <Typography variant="subtitle" component="div">
        Selected: {selectedValue}
      </Typography>
      <br />
      <Button variant="contained" onClick={handleClickOpen}>
        Open simple dialog
      </Button>
      <SimpleDialog
        selectedValue={selectedValue}
        open={open}
        onClose={handleClose}
      />
      
      <ShowCode 
        codeString={`<>
  {/* Component state */}
  const [open, setOpen] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState('user@example.com');

  {/* Dialog component */}
  <Typography variant="subtitle1">
    Selected: {selectedValue}
  </Typography>
  
  <Button variant="contained" onClick={() => setOpen(true)}>
    Open simple dialog
  </Button>
  
  <Dialog onClose={() => setOpen(false)} open={open}>
    <DialogTitle>Select an account</DialogTitle>
    <List sx={{ pt: 0 }}>
      {['user1@example.com', 'user2@example.com'].map((email) => (
        <ListItem disableGutters key={email}>
          <ListItemButton onClick={() => {
            setSelectedValue(email);
            setOpen(false);
          }}>
            <ListItemAvatar>
              <Avatar>
                <PersonIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={email} />
          </ListItemButton>
        </ListItem>
      ))}
      
      <ListItem disableGutters>
        <ListItemButton onClick={() => {
          setSelectedValue('Add new account');
          setOpen(false);
        }}>
          <ListItemAvatar>
            <Avatar>
              <AddIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary="Add account" />
        </ListItemButton>
      </ListItem>
    </List>
  </Dialog>
</>`} 
        scope={{ 
          React, 
          Button, 
          Avatar, 
          List, 
          ListItem, 
          ListItemAvatar, 
          ListItemButton, 
          ListItemText, 
          DialogTitle, 
          Dialog, 
          PersonIcon, 
          AddIcon, 
          Typography 
        }} 
      />
    </>
  );
}